import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import Home from './Home';
import Competition from './competitions/Competition';
import Archive from './archive';

const HomeRouter = props => {
  return (
    <Switch>
      <Route exact path="/" component={Home} {...props} />
      <Route exact path="/home" component={Home} {...props} />
      <Route exact path="/home/archive" component={Archive} {...props} />
      <Route exact path="/home/archive/:slug" component={Archive} {...props} />

      <Route
        exact
        path="/home/competitions/:competitionId"
        component={Competition}
        {...props}
      />
    </Switch>
  );
};

HomeRouter.propTypes = {
  match: PropTypes.object.isRequired,
};

export default HomeRouter;
